import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
    bgColor: "#2f3640",
    textColor: "#f5f6fa",
    accentColor: "#9c88ff",
    boxColor: "#fff",
    textInBox: "#2f3640",
};

export const lightTheme: DefaultTheme = {
    bgColor: "#fff",
    textColor: "#2f3640",
    accentColor: "#9c88ff",
    boxColor: "#2f3640",
    textInBox: "#fff",
};